import axios from 'axios'
import { useAuthStore } from '../stores/auth'

// When bundled inside APK (capacitor://localhost), relative /api doesn't work.
// VITE_API_URL must be set to the absolute backend URL for APK builds.
const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined) || '/api'

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  // Без таймаута запрос на плохой сети (напр. перегруз в День города) висит
  // бесконечно → вечная «Загрузка…». 20 c хватает любому нормальному ответу
  // (реальные — десятки мс), а на мёртвой сети запрос честно падает с ошибкой.
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      try {
        const storedRefresh = useAuthStore.getState().refreshToken
        const { data } = await axios.post(
          `${BASE_URL}/auth/refresh`,
          storedRefresh ? { refreshToken: storedRefresh } : {},
          { withCredentials: true },
        )
        useAuthStore.getState().setAccessToken(data.accessToken)
        original.headers.Authorization = `Bearer ${data.accessToken}`
        return api(original)
      } catch {
        // Let React Router's RequireAuth handle the redirect — no hard reload
        useAuthStore.getState().logout()
      }
    }
    return Promise.reject(error)
  },
)
